import { PaymentSchedule } from "@covertree/agent-portal-graphql";

export function mapPaymentSchedule(paymentSchedule: PaymentSchedule): string {
  switch (paymentSchedule) {
    case PaymentSchedule.FullPay:
      return "Full-Pay";
    case PaymentSchedule.TwoPay:
      return "2-Pay";
    case PaymentSchedule.ElevenPay:
      return "11-Pay";
    case PaymentSchedule.MortgageBill:
      return "Mortgage-billed";
  }
}
